/** localStorage key — keep identical across Oujat web apps on the same origin. */
export const COOKIE_CONSENT_STORAGE_KEY = 'oujat_cookie_consent_v1'

/** Values: `all` (accept non-essential where applicable), `essential` (strict minimum). */
export function getStoredCookieConsent() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
  } catch {
    return null
  }
}

export function setStoredCookieConsent(value) {
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, value)
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * REACT_APP_COOKIE_CONSENT_MODE:
 * - `eu` (default): prompt only when visitor timezone looks EU/EEA-related (heuristic, not legal geo-IP).
 * - `all`: always prompt until answered (global banner).
 * - `off`: never show banner.
 */
export function getCookieConsentMode() {
  const raw = (process.env.REACT_APP_COOKIE_CONSENT_MODE || 'eu').toLowerCase().trim()
  if (raw === 'off' || raw === 'false' || raw === '0') return 'off'
  if (raw === 'all' || raw === 'global') return 'all'
  return 'eu'
}

/** European parts of Russia, Turkey, Belarus, etc. — still `Europe/` tz id but not EU/EEA. */
const NON_EU_EUROPE_TIMEZONES = new Set([
  'Europe/Istanbul',
  'Europe/Minsk',
  'Europe/Moscow',
  'Europe/Simferopol',
  'Europe/Volgograd',
  'Europe/Kirov',
  'Europe/Astrakhan',
  'Europe/Samara',
  'Europe/Ulyanovsk',
  'Europe/Kaliningrad',
  'Europe/Saratov',
])

export function isLikelyEuOrEeaTimezone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!tz) return false
    if (NON_EU_EUROPE_TIMEZONES.has(tz)) return false
    if (tz.startsWith('Europe/')) return true
    return ['Atlantic/Canary', 'Atlantic/Faroe', 'Atlantic/Madeira', 'Africa/Ceuta'].includes(tz)
  } catch {
    return false
  }
}

/** True if the first-visit banner should be shown (no prior choice + mode allows). */
export function shouldShowCookieConsentBanner() {
  if (getStoredCookieConsent()) return false
  const mode = getCookieConsentMode()
  if (mode === 'off') return false
  if (mode === 'all') return true
  return isLikelyEuOrEeaTimezone()
}
